
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 1.15033C9.0612 1.15033 6.67883 3.5327 6.67883 6.4715V8.78513C4.65395 8.98238 3.07141 10.6894 3.07141 12.7661V18.8498C3.07141 21.0589 4.86227 22.8498 7.07141 22.8498H16.9287C19.1378 22.8498 20.9287 21.0589 20.9287 18.8498V12.7661C20.9287 10.6894 19.3461 8.98234 17.3212 8.78513V6.4715C17.3212 3.5327 14.9388 1.15033 12 1.15033ZM15.3212 8.76611V6.4715C15.3212 4.63727 13.8342 3.15033 12 3.15033C10.1658 3.15033 8.67883 4.63727 8.67883 6.4715V8.76611H15.3212ZM7.07141 10.7661C5.96684 10.7661 5.07141 11.6615 5.07141 12.7661V18.8498C5.07141 19.9543 5.96684 20.8498 7.07141 20.8498H16.9287C18.0332 20.8498 18.9287 19.9543 18.9287 18.8498V12.7661C18.9287 11.6615 18.0332 10.7661 16.9287 10.7661H7.07141ZM12.0001 17.1578C11.2545 17.1578 10.6501 16.5766 10.6501 15.8597V15.7559C10.6501 15.0389 11.2545 14.4578 12.0001 14.4578C12.7457 14.4578 13.3501 15.0389 13.3501 15.7559V15.8597C13.3501 16.5766 12.7457 17.1578 12.0001 17.1578Z","fill":"#16171F"}})])
          )
        }
      }
    